import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatSqm'
})
export class FormatSqmPipe implements PipeTransform {
  transform(value: any, language: string = 'en'): string {
    // Convert the value to a string to ensure the match function works correctly
    const valueString = String(value);
    
    // Extract numeric value using regex
    // const numericValue = valueString.match(/[0-9.]+/g)?.join('') || '';
    const numericValue = valueString.match(/[0-9.+]+/g)?.join('') || '';
    // Define translations for sqm
    const translations = {
      en: 'sqm',
      he: 'מ"ר',
      ar: 'م²'
    };

    // Return formatted string
    return `${numericValue} ${translations[language] || translations['en']}`;
  }
}
